import { storyPageContent } from "../data/services";
import { motion } from "framer-motion";
import ServicesBanner from "../components/common/ServicesBanner";
import userImg from "../assets/icons/CLIENTImg.png";
import OpportunitiesImg from "../assets/icons/OPPORTUNITIESImg.png";
import ChallengesImg from "../assets/icons/CHALLENEGS.jpg";
import SuccessImg from "../assets/icons/SUCCESS.jpg";
const SuccessStory2 = () => {

  const { bannerTitle, bannerImage } =
    storyPageContent;
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.5 },
    }),
  };
  const cards = [
    {
      title: "背景",
      img: userImg,
      description:
        "• 当社のクライアントは、企業にSaaSベースの金融インフラストラクチャを提供する、大手のBanking as a Service（BaaS）プロバイダーです。 \n • イノベーションに重点を置いて、国際送金、ブランドカードの発行、BNPL（今すぐ購入、後払い）などの銀行サービスのシームレスな統合を実現していました。 ",
    },
    {
      title: "機会",
      img: OpportunitiesImg,
      description:
        "• クライアントは、24時間365日、アプリケーション監視プロセスを完全に管理できるパートナーを探していました。 \n • 当社のチームは現在このクライアントを2年以上サポートしています。\n • 最先端のPCI-DSS準拠のCoEがすぐに使用できるようになりました。 ",
    },
    {
      title: "課題",
      img: ChallengesImg,
      description:
        "• リソースの過剰利用。\n• サービスの改善ではなくトラブルシューティングに多くの時間が浪費。\n • 個々のリソースの作業負荷の増加。\n • サービスレベル管理構造がないため、効率が低下。  ",
    },
    {
      title: "解決策と成功",
      img: SuccessImg,
      description:
        "• インフラストラクチャの準備状況に基づいて、初日から1日3交代 シフトで開始しました。 \n • 私たちは現在、開発チームを支援して、コードのトラブルシューティング、モバイルアプリのテスト、REST APIテスト、MySQLデータベースを使用したデータレベルの修正、開発環境と本番環境におけるいくつかの重要なAWSインフラストラクチャ アクティビティを行っています。 ",
    },
  ];
  return (
    <div className="bg-gradient-to-b from-white to-gray-100 mb-5 mx-auto">
      {/* Banner Section */}
      <ServicesBanner title={bannerTitle} heroImage={bannerImage} />
      <div className="max-w-5xl mx-auto md:px-10 lg:px-10 lg:max-w-fit">
        <div className="flex justify-center items-center">
          {/* Header Section */}
          <div className="m-5">
            <h1 className="text-3xl font-bold mt-2">
              <span> リテールバンキング</span>
            </h1>
          </div>
        </div>
        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-x-10 gap-y-10 w-full max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl hover:shadow-blue-100 p-10 transition duration-300 ease-in-out"
            >
              <div className="flex items-center gap-4 mb-4">
                <img src={card.img} alt={card.title} className="w-16 h-16 rounded-full border border-gray-200" />
                <h3 className="text-2xl font-semibold text-blue-700">
                  {card.title}
                </h3>
              </div>
              <p className="text-gray-800 leading-relaxed text-lg">{card.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStory2;
